import React, { useEffect, useRef } from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { BadgeCheck, Loader2 } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import { mark_customer_as_verified } from '../redux/reducer';
import { getVerifyAccountLoading } from '../redux/selectors';

function ConfirmVerify({ id, isOpen, onOpenChange }) {
  const dispatch = useDispatch();
  const verifying = useSelector(getVerifyAccountLoading);
  const wasVerifying = useRef(false);

  // Close as soon as the request settles; the saga toasts the result.
  useEffect(() => {
    if (wasVerifying.current && !verifying) onOpenChange(false);
    wasVerifying.current = verifying;
  }, [verifying, onOpenChange]);

  const handleOpenChange = (open) => {
    if (!verifying) onOpenChange(open);
  };

  return (
    <Dialog.Root open={isOpen} onOpenChange={handleOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-50 bg-black/50 backdrop-blur-sm" />
        <Dialog.Content className="fixed left-1/2 top-1/2 z-50 w-[calc(100%-2rem)] max-w-[420px] -translate-x-1/2 -translate-y-1/2 p-6 bg-white rounded-2xl shadow-xl font-outfit focus:outline-none">
          <div className="grid place-items-center w-12 h-12 rounded-full bg-[#549A9A]/10 text-[#549A9A]">
            <BadgeCheck size={22} />
          </div>
          <Dialog.Title className="mt-4 text-[18px] font-semibold text-[#1F2937]">
            Verify this account?
          </Dialog.Title>
          <Dialog.Description className="mt-1 text-[14px] text-[#6B7280]">
            This marks the user's email as verified without them confirming it
            themselves.
          </Dialog.Description>
          <div className="flex gap-3 justify-end mt-6">
            <button
              type="button"
              disabled={verifying}
              onClick={() => onOpenChange(false)}
              className="h-[42px] px-5 rounded-[10px] border border-[#DDDDDD] bg-white text-[14px] font-semibold text-[#333333] hover:bg-[#F3F4F6] disabled:opacity-60"
            >
              Cancel
            </button>
            <button
              type="button"
              disabled={verifying}
              onClick={() => dispatch(mark_customer_as_verified(id))}
              className="flex gap-2 items-center h-[42px] px-5 rounded-[10px] bg-[#549A9A] hover:bg-[#447f7f] text-[14px] font-semibold text-[#E2FFEE] transition-colors disabled:opacity-60"
            >
              {verifying && <Loader2 size={16} className="animate-spin" />}
              {verifying ? 'Verifying…' : 'Verify account'}
            </button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}

export default ConfirmVerify;
